import React, { useContext, useEffect, useState, useRef } from "react";
import axios from "axios";
import URLAPI from "../../helpers/Path";
import { MDBInput, MDBRow, MDBCol, MDBTextArea } from "mdb-react-ui-kit";
import DatePicker from "react-datepicker";
import Alerts from "../Alerts";
import "react-datepicker/dist/react-datepicker.css";
import { Form } from "react-bootstrap";
import { useParams } from "react-router-dom";
import tache from "../../assets/TACHE NOTARIA.png";
import ReactDOM from "react-dom";
import { UsuarioContext } from "../context/UsuarioContext.jsx";
import { useUsuarioStore } from "../zustandShared/usuarioStore.js";

import {
  AutoComplete_Create,
  AutoComplete_Destroy,
} from "../js/AutoComplete.js";

const EditC = () => {
  //Obtener el id de la url
  const { id_user } = useParams();

  // -----------------------------------------------------------------------------------------------------------

  // Bool para que el evento no se ejecute el doble si el usuario le presiona mientras se esta concluyendo el evento en un boton
  const [loading, setLoading] = useState(false);

  // --------------------------------------------------------------------------------------------------

  // Usamos useContext solamente cuando EditC se va a usar como componente para otros apartados de la pagina, sino automaticamente se mandara como null
  const { abrirBuscar, setAbrirBuscar } = useContext(UsuarioContext) || {};
  // -----------------------------------------------------------------------------------------------------------
  //Obtenemos de zustand, las variables necesarias solamente cuando EditC se comportara como componente para otros componentes de React
  const {
    agregarAdquiriente,
    agregarOtorgante,
    boolAdquiriente,
    boolOtorgante,
    setCerrarModal,
  } = useUsuarioStore();
  //-----------------------------------------------------------------------------------------------------------------

  //Todo del modal para guardar archivos
  //Variable de estado para insertar html crudo.
  const [modalHTML, setModalHTML] = useState("");

  // -----------------------------------------------------------------------------------------------------

  //Estado que guardara el nombre de la busqueda realizada
  const [busqueda, setBusqueda] = useState("");

  //Estado que guardara el id del cliente seleccionado
  const [idcliente, setIdcliente] = useState("");
  //Estado que guardara todos los clientes
  const [clientes, setClientes] = useState([]);
  //Variable de estado para recargar la pagina
  const [isCreated, setIsCreated] = useState(false);
  //Endpoint que llevara los datos actualizados al backend
  const clientesUpdatePhp = URLAPI + "actualiza_cliente.php";
  //Endpoint para obtener información del cliente seleccionado
  const clientesearchphp = URLAPI + "info_cliente.php";
  //Endpoint para obtener todos los clientes
  const clientesphp = URLAPI + "trae_clientes.php";
  //EndPoint para borrar los archivos en el modo edición
  const borra_archivo = URLAPI + "borra_archivo_edicion.php";
  //Enpoint para obtener los archivos del cliente seleccionado
  const obtener_archivos = URLAPI + "archivos_cliente.php";
  // Trae todos los archivos que se han guardado anteriormente
  const tempo_archivos = URLAPI + "archivos_edicion.php";
  // Contiene la ventana emergente
  const poparchivosURL = URLAPI + "poparchivos.php";
  // Variable del alert que aparece cuando se logra editar el cliente de forma correcta
  const [isAlert2, setIsAlert2] = useState(false);
  // Variable que aparece cuando no se ha seleccionado ningun cliente
  const [isAlert3, setIsAlert3] = useState(false);

  //Variable que guarda el id_usuario de los documentos
  const [id_user_doc, setid_user_doc] = useState("");

  // Catalogos para los selects
  const id_nacionalidadPhp = URLAPI + "lista_nacionalidad.php";
  const id_estadoPhp = URLAPI + "lista_estado.php";
  const id_regimenPhp = URLAPI + "lista_regimen.php";
  const id_regimen_fiscalPhp = URLAPI + "lista_regimen_fiscal.php";
  const id_lista_paisPhp = URLAPI + "lista_pais.php";

  // Establecer variables donde se mantendra el guardado de datos del formulario
  const [id_nacionalidad, setid_nacionalidad] = useState(0);
  const [id_estado, setid_estado] = useState(0);
  const [id_regimen, setid_regimen] = useState(0);
  const [id_regimen_fiscal, setid_regimen_fiscal] = useState(0);
  const [id_pais, setid_pais] = useState(0);
  const [datosCliente, setDatosCliente] = useState({});
  const [cp, setCp] = useState("");
  const [rfc_moral, setrfc_moral] = useState("");

  // Establecer variables donde se mantendran los selects
  const [nacionalidades, setNacionalidades] = useState([]);
  const [estados, setEstados] = useState([]);
  const [regimenes, setRegimenes] = useState([]);
  const [regimenesFiscales, setRegimenesFiscales] = useState([]);
  const [paises, setPaises] = useState([]);

  //Ref para las vigencias
  const archivo_fecharef = useRef(null);
  // Messages
  const [msgError, setMsgError] = useState("");
  //Variables de estado del alert para mostrar los errores de registro
  const [isAlert, setIsAlert] = useState(false);
  //Cambiar la vigencia de un archivo
  const [archive, setArchive] = useState([]);

  //Iluminar errores del registro -------------------------------------------------------------------------------
  // Referencias para persona física
  const nombreRef = useRef(null);
  const ap_paternoRef = useRef(null);
  const ap_maternoRef = useRef(null);
  const tambien_conocidoRef = useRef(null);
  const id_nacionalidadRef = useRef(null);
  const lugar_nacimientoRef = useRef(null);
  const fecha_nacimientoRef = useRef(null);
  const ocupacionRef = useRef(null);
  const curpRef = useRef(null);
  const rfcRef = useRef(null);
  const id_estadoRef = useRef(null);
  const id_regimenRef = useRef(null);

  // Referencias para persona moral
  const razon_socialRef = useRef(null);
  const representante_legalRef = useRef(null);
  const rfc_moralRef = useRef(null);

  // Referencias domicilio
  const calleRef = useRef(null);
  const no_exteriorRef = useRef(null);
  const coloniaRef = useRef(null);
  const localidadRef = useRef(null);
  const ciudadRef = useRef(null);
  const estadoRef = useRef(null);
  const paisRef = useRef(null);
  const id_paisRef = useRef(null);
  const cpRef = useRef(null);

  // Referencias contacto
  const telefono_movilRef = useRef(null);
  const correo_electronicoRef = useRef(null);

  const inputRef = useRef(null);

  // -------------------------------------------------------------------------------------------------------------------
  // Variable booleana que se encarga de saber si el modal de archivos debe de estar abierto o no
  const [showModal, setShowModal] = useState(false);

  // Este useffect se encarga de mostrar la ventana emergente hecha en html que se obtiene a traves del servidor php, cuando se cierra se manda a llamar a los archivos que estaban guardados en terminacion f

  useEffect(() => {
    if (showModal) {
      var caracteristicas = "left=150, top=50, width=750, height=440";
      const popup = window.open(
        `${poparchivosURL}?id_user=${id_user}`,
        "",
        caracteristicas,
      );

      const timer = setInterval(async () => {
        if (popup && popup.closed) {
          clearInterval(timer);
          //alert("La ventana esta cerrada");
          try {
            const res = await axios.post(
              `${tempo_archivos}?id_user=${id_user}&id_cliente=${idcliente}`,
            );

           // console.log("respuesta del tempo archivos", res.data);

            // Dentro de tu useEffect, después de llamar a obtener_archivos:

            if (res) {
              const archivosNuevosDelBackend = Object.values(res.data);
              //console.log("archivos nuevos del backend", archivosNuevosDelBackend)

              // 1. Convertir el estado actual (local) a un mapa para búsqueda rápida
              const archivoVigenciasLocales = (
                Array.isArray(archive) ? archive : Object.values(archive)
              ).reduce((map, item) => {
                // Usamos el nombre como clave única
                map[item.nombre] = item.vigencia;
                //console.log("Archivo local", item.nombre, "Vigencia local", item.vigencia);
                return map;
              }, {});
              //console.log("Vigencias locales", archivoVigenciasLocales);

              //2.
              const archivosFechaslocales = (
                Array.isArray(archive) ? archive : Object.values(archive)
              ).reduce((map, item) => {
                // Usamos el nombre como clave única
                map[item.nombre] = item.fecha_carga; // Aseguramos que la vigencia esté actualizada
                //console.log("Archivo local", item.nombre, "Fecha de carga", item.fecha_carga);
                return map;
              }, {});
              //console.log("Fechas de carga locales", archivosFechaslocales);

              // 2. Mapear los nuevos archivos, inyectando la vigencia local si existe
              const archivosFinales = archivosNuevosDelBackend.map(
                (archivoOriginal) => {
                  const nombre =
                    typeof archivoOriginal === "string"
                      ? archivoOriginal
                      : archivoOriginal.nombre;

                  // Obtener la vigencia local guardada, si existe.
                  const vigenciaLocal = archivoVigenciasLocales[nombre];

                  // Obtener la fecha de carga actual guardada, si existe.
                  const fechalocal = archivosFechaslocales[nombre];

                  if (vigenciaLocal !== undefined && fechalocal !== undefined) {
                    // Si el archivo ya existía y tenía vigencia local, la usamos.
                    return {
                      nombre: nombre,
                      vigencia: vigenciaLocal,
                      fecha_carga: fechalocal,
                    };
                  }

                  //

                  // Si no había vigencia local (es un archivo nuevo o no se modificó),
                  // usamos la lógica de normalización original.
                  return typeof archivoOriginal === "string"
                    ? { nombre: archivoOriginal, fecha: "" }
                    : archivoOriginal;
                },
              );


              const archivosUnicos = [
                ...new Map(archivosFinales.map((a) => [a.nombre, a])).values(),
              ];
             // console.log("Archivos finales con vigencias y fechas locales", archivosUnicos);
             

              setArchive(archivosUnicos);
              
              //console.log("Archivos cambiados", archivosArraycambiados);
            }
            //console.log(res);

            /* if (res) {
                  console.log("Se ha logrado desplegar los archivos")
                }*/
          } catch (error) {
            console.log("Error al subir los archivos", error);
          }
        }
      }, 500);
      setShowModal(false);
      /*const modal = document.querySelector(".modal");
          if (modal && window.bootstrap) {
            const bootstrapModal = new window.bootstrap.Modal(modal);
            bootstrapModal.show();
          }*/
    }
  }, [showModal]);

  // -------------------------------------------------------------------------------------------------------------

  //Estas funciones son para EditC cuando es componente de otro componente en react, se encargan de abrir y cerrar un modal en el que editc forma parte

  const cerrar_Modal = () => {
    setCerrarModal(false);
    setAbrirBuscar(false);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };
  // ----------------------------------------------------------------------------------------------------------

  // Funcion que se usa par recargar la pagina cuando se aparece el alert de guardado exitoso
  useEffect(() => {
    if (isCreated) {
      window.location.reload();
    }
  }, [isCreated]);
  // ---------------------------------------------------------------------------------------------------------------------

  //Este codigo se encarga de hacer una petición para llamar a la ventana emergente

  const handleOpenModal = async () => {
    try {
      const res = await axios.get(poparchivosURL);
      //setModalHTML(res.data);
      setShowModal(true);
    } catch (error) {
      console.error("Error al cargar el modal:", error);
    }
  };
  // ----------------------------------------------------------------------------------------------------------------------

  //Expresiones reguladas
  const curpRegex =
    /^([A-Z][AEIOUX][A-Z]{2}\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])[HM](?:AS|B[CS]|C[CLMSH]|D[FG]|G[TR]|HG|JC|M[CNS]|N[ETL]|OC|PL|Q[TR]|S[PLR]|T[CSL]|VZ|YN|ZS)[B-DF-HJ-NP-TV-Z]{3}[A-Z\d])(\d)$/;

  const rfcRegexphysics =
    /^([A-ZÑ&]{4}) ?(?:- ?)?(\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])) ?(?:- ?)?([A-Z\d]{2})([A\d])$/;

  const rfcRegexlegalentity =
    /^([A-ZÑ&]{3}) ?(?:- ?)?(\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])) ?(?:- ?)?([A-Z\d]{2})([A\d])$/;

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  //---------------------------------------------------------------------------------------------------------------------
  // Configuración y diseño para que no se pueda ingresar ningun texto al imput de selecciona tu fecha de nacimiento

  const CustomDateInput = React.forwardRef(({ value, onClick }, ref) => (
    <div className="position-relative w-100">
      <input
        type="text"
        className="form-control pe-5"
        value={value}
        placeholder="Selecciona tu fecha de nacimiento"
        readOnly
        ref={ref}
      />
      <button
        type="button"
        className="btn btn-warning position-absolute top-50 end-0 translate-middle-y me-1 d-flex align-items-center gap-1"
        onClick={onClick}
        style={{
          borderRadius: "8px",
          fontWeight: "bold",
        }}
      >
        <i className="fas fa-caret-down"></i>
      </button>
    </div>
  ));

  // -------------------------------------------------------------------------------------------------------------------

  //Función para iluminar los input en general

  const focusAndHighlight = (inputRef) => {
    if (!inputRef?.current) return;

    inputRef.current.focus();
    const originalBorder = inputRef.current.style.border;
    const originalBackground = inputRef.current.style.backgroundColor;

    // Resaltar con borde rojo y fondo ligeramente rosado
    inputRef.current.style.border = "2px solid red";
    inputRef.current.style.backgroundColor = "#ffe6e6";

    setTimeout(() => {
      inputRef.current.style.border = originalBorder;
      inputRef.current.style.backgroundColor = originalBackground;
    }, 2000);
  };

  // --------------------------------------------------------------------------------------------------------------------------

  // Maneja la selección del autocomplete

  useEffect(() => {
    if (!inputRef.current) return;

    const handleSelect = async () => {
      setTimeout(async () => {
        const idSeleccionado = inputRef.current.dataset.id; // ID del cliente seleccionado
        const nombreSeleccionado = inputRef.current.value; // Nombre mostrado en el input

        if (idSeleccionado) {
          //console.log("📌 ID seleccionado:", idSeleccionado);
          setIdcliente(idSeleccionado);
          setBusqueda(nombreSeleccionado);

          try {
            const res = await axios.post(clientesearchphp, {
              data: idSeleccionado,
            });

            //console.log("respuesta de info cliente", res.data.id_usuario);

            setid_user_doc(res.data.id_usuario);

            //console.log("Datos de la cuenta:", res.data);

            //console.log("Datos del cliente obtenidos:", res);

            setDatosCliente(res.data);

            //setArchive(res.data.archivos)

            const response = await axios.post(obtener_archivos, {
              id_seleccionado: idSeleccionado,
            });

           // console.log("respuesta del servidor", response);

            const responseArray = Object.values(response.data);

            //console.log("responseArray", responseArray)

            //Normalizar elementos, convertir string a objetos
            const archivosNormalizados = responseArray.map((archivo, index) => {
              if (typeof archivo === "string") {
                return {
                  fecha_carga: "2025-09-30",
                  id_cliente: "2",
                  id_documento: String(index + 1),
                  id_expediente: "0",
                  nombre: archivo,
                  usuario: "CESAR",
                  fecha: "3",
                };
              } else {
                // Si ya es objeto, lo dejamos tal cual
                return archivo;
              }
            });

            const archivosArray = Object.values(archivosNormalizados);

            setArchive(archivosArray);
          } catch (error) {
            console.error("Error recuperando datos:", error);
          }
        }
      }, 0);
    };
    // --------------------------------------------------------------------------------------------------------------

    // Escucha teclas enter o space y la selección de texto en un input y llama a la función handleselect donde se obtiene la información de ese cliente
    const handleKeyDown = (e) => {
      if (e.code === "Space" || e.code === "Enter") {
        e.preventDefault();
        handleSelect();
      }
    };

    inputRef.current.addEventListener("keydown", handleKeyDown);
    inputRef.current.addEventListener("select", handleSelect);
    //Cuando se desmonta el componente, quita los listener para evitar problemas
    return () => {
      if (inputRef.current) {
        inputRef.current.removeEventListener("change", handleSelect);
      }
    };
  }, [clientes, clientesearchphp]);
  // -----------------------------------------------------------------------------------------------------------------

  //Función que se ejecuta cuando se quiere borrar un archivo directamente a traves del boton de la "x"
  const delete_files = async (archivoNombre, id_documento) => {

    try {
      const res = await axios.post(
        `${borra_archivo}?file_name=${archivoNombre}&id_documento=${id_documento}`,
      );

     // console.log("borra_archivo", res)

      if (res) {
        setArchive((prev) =>
          prev.filter((f) =>
            typeof f === "string"
              ? f !== archivoNombre
              : f.nombre !== archivoNombre,
          ),
        );
      }
    } catch (error) {
      console.error("No se logró borrar el archivo", error);
    }
  };
  // ---------------------------------------------------------------------------------------------------------

  //Función que determina cual archivo debe de estar en rojo
  const file_date = (vigencia, fecha_carga) => {
    if (fecha_carga) {
      const vigencia_number = Number(vigencia);
      // Fecha actual
      const fecha_actual = new Date();

      // console.log("Fecha actual:", fecha_actual);

      // Convertimos fecha de carga a Date
      const partes = fecha_carga.split("-");
      const fechaObj = new Date(partes[0], partes[1] - 1, partes[2]);

      // console.log("Fecha de carga del archivo:", fechaObj);

      // Sumamos vigencia en meses
      fechaObj.setMonth(fechaObj.getMonth() + vigencia_number);

      // console.log("Vigencia en meses:", vigencia_number);

      // console.log("Fecha límite del archivo:", fechaObj);

      // Comparación
      return fechaObj < fecha_actual;
    }
  };
  // ------------------------------------------------------------------------------------------------------------------

  //Función que determinar cual input tiene el error y lo ilumina
  const getRefFromError = () => {
    switch (msgError) {
      // Persona moral
      case "Campo de razón social vacío":
        return razon_socialRef;
      case "Campo de representante legal vacío":
        return representante_legalRef;
      case "Campo de RFC moral vacío":
        return rfc_moralRef;
      case "RFC moral inválido":
        return rfc_moralRef;
      // Persona física
      case "Campo Nombre vacío":
        return nombreRef;
      case "Campo de apellido paterno vacío":
        return ap_paternoRef;
      case "Campo de apellido materno vacío":
        return ap_maternoRef;
      case "Campo de también conocido como se encuentra vacío":
        return tambien_conocidoRef;
      case "Campo de nacionalidad no seleccionado":
        return id_nacionalidadRef;
      case "Campo de fecha de nacimiento vacío":
        return fecha_nacimientoRef;
      case "Campo de lugar de nacimiento vacío":
        return lugar_nacimientoRef;
      case "Campo de ocupación vacío":
        return ocupacionRef;
      case "Campo de C.U.R.P. vacio":
      case "C.U.R.P. inválido":
        return curpRef;
      case "Campo de R.F.C. vacío":
      case "RFC inválido":
        return rfcRef;
      case "Campo de estado civil no seleccionado":
        return id_estadoRef;
      case "Campo de régimen civil no seleccionado":
        return id_regimenRef;

      //Archivos
      case "Campos de vigencia vacios":
        return archivo_fecharef;

      // Domicilio
      case "Campo de calle vacío":
        return calleRef;
      case "Campo de No. exterior vacío":
        return no_exteriorRef;
      case "Campo de colonia vacío":
        return coloniaRef;
      case "Campo de localidad vacío":
        return localidadRef;
      case "Campo de ciudad vacío":
        return ciudadRef;
      case "Campo de estado vacío":
        return estadoRef;
      case "Campo de país no seleccionado":
        return id_paisRef;
      case "Campo de CP vacío":
        return cpRef;
      case "El campo de CP solo acepta números":
        return cpRef;

      // Contacto
      case "Campo de teléfono móvil vacío":
        return telefono_movilRef;
      case "Campo de correo electrónico está vacío":
      case "Correo electronico inválido":
        return correo_electronicoRef;

      default:
        return null; // Si no hay match
    }
  };
  // ------------------------------------------------------------------------------------------------------------------

  // Funciones que determinan cuando cambia un input y a traves de esto si esta vacio o no
  const handleInputChange = (e, field) => {
    const value = e.target.value;
    setDatosCliente((prev) => ({ ...prev, [field]: value }));

    // Validaciones
    setMsgError(""); // limpiar error previo
    switch (field) {
      //Persona moral
      case "razon_social":
        if (!value) setMsgError("Campo de razón social vacío");
        break;
      case "representante":
        setDatosCliente((prev) => ({ ...prev, representante: value }));
        if (!value) setMsgError("Campo de representante legal vacío");
        else setMsgError("");
        break;

      //Persona fisica
      case "nombre":
        if (!value) setMsgError("Campo Nombre vacío");
        break;
      case "ap_paterno":
        if (!value) setMsgError("Campo de apellido paterno vacío");
        break;
      case "ap_materno":
        if (!value) setMsgError("Campo de apellido materno vacío");
        break;
      case "tambien_conocido":
        if (!value)
          setMsgError("Campo de también conocido como se encuentra vacío");
        break;
      case "curp":
        if (!value) setMsgError("Campo de C.U.R.P. vacio");
        else if (!curpRegex.test(value.toUpperCase()))
          setMsgError("C.U.R.P. inválido");
        break;
      case "rfc":
        if (datosCliente.tipo_cliente === "1") {
          if (!value) setMsgError("Campo de R.F.C. vacío");
          else if (!rfcRegexphysics.test(value.toUpperCase()))
            setMsgError("RFC inválido");
          break;
        } else {
          const valor = e.target.value.toUpperCase();
          setDatosCliente((prev) => ({ ...prev, rfc: valor }));
          setrfc_moral(valor);
          setMsgError("");

          if (valor.trim() === "") {
            setMsgError("Campo de RFC moral vacío");
          } else if (!rfcRegexlegalentity.test(valor)) {
            setMsgError("RFC moral inválido");
          }
          break;
        }

      case "mail":
        if (!value) setMsgError("Campo de correo electrónico está vacío");
        else if (!emailRegex.test(value.toUpperCase()))
          setMsgError("Correo electronico inválido");
        break;

      case "lugar_nacimiento":
        if (!value) setMsgError("Campo de lugar de nacimiento vacío");
        break;
      case "ocupacion":
        if (!value) setMsgError("Campo de ocupación vacío");
        break;
      case "calle":
        if (!value) setMsgError("Campo de calle vacío");
        break;
      case "numero_exterior":
        if (!value) setMsgError("Campo de No. exterior vacío");
        break;
      case "colonia":
        if (!value) setMsgError("Campo de colonia vacío");
        break;
      case "localidad":
        if (!value) setMsgError("Campo de localidad vacío");
        break;
      case "ciudad":
        if (!value) setMsgError("Campo de ciudad vacío");
        break;
      case "estado":
        if (!value) setMsgError("Campo de estado vacío");
        break;
      case "cp":
        setCp(e.target.value);
        setMsgError(""); // Limpiar mensaje de error

        if (e.target.value === "") {
          setMsgError("Campo de CP vacío");
        } else if (!/^\d*$/.test(e.target.value)) {
          setMsgError("El campo de CP solo acepta números");
        }
        break;
      case "telefono_movil":
        if (!value) setMsgError("Campo de teléfono móvil vacío");
        break;
      default:
    }
  };

  // -------------------------------------------------------------------------------------------------------------

  //Funciones que determinan el guardado de los enlistados del formulario
  const handleChangeid_nacionalidad = (e) => {
    const nacionalidad = parseInt(e.target.value);
    setid_nacionalidad(nacionalidad);
    setDatosCliente((prev) => ({
      ...prev,
      id_nacionalidad: nacionalidad,
    }));
  };

  const handleChangeid_estado = (e) => {
    const estadoSeleccionado = parseInt(e.target.value);

    // Actualizamos el estado civil en el useState y en datosCliente
    setid_estado(estadoSeleccionado);
    setDatosCliente((prev) => ({ ...prev, id_estado: estadoSeleccionado }));

    // Si el estado no es Casado (id_estado !== 1), reseteamos régimen
    if (estadoSeleccionado !== 1) {
      setid_regimen(0); // o ""
      setDatosCliente((prev) => ({ ...prev, id_regimen: 0 }));
    }
  };

  const handleChangeid_regimen = (e) => {
    const regimen = parseInt(e.target.value);

    setid_regimen(regimen);
    setDatosCliente((prev) => ({
      ...prev,
      id_regimen: regimen,
    }));
  };

  const handleChangeid_regimen_fiscal = (e) => {
    const regimen_fiscal = parseInt(e.target.value);

    setid_regimen_fiscal(regimen_fiscal);
    setDatosCliente((prev) => ({
      ...prev,
      id_regimen_fiscal: regimen_fiscal,
    }));
  };

  const handleChangePais = (e) => {
    const pais = e.target.value;

    setid_pais(pais);
    setDatosCliente((prev) => ({
      ...prev,
      id_pais: pais,
    }));
  };
  // --------------------------------------------------------------------------------------------------------------------

  // Obtener catálogos
  useEffect(() => {
    axios.get(id_nacionalidadPhp).then((res) => setNacionalidades(res.data));
    axios.get(id_estadoPhp).then((res) => setEstados(res.data));
    axios.get(id_regimenPhp).then((res) => setRegimenes(res.data));
    axios
      .get(id_regimen_fiscalPhp)
      .then((res) => setRegimenesFiscales(res.data));
    axios.get(id_lista_paisPhp).then((res) => setPaises(res.data));
  }, []);
  // ---------------------------------------------------------------------------------------------------------------------

  //Este useEffect se encarga de obtener todos los clientes desde el backend
  //Inicializa un autocompletado con hasta 10 clientes maximo

  useEffect(() => {
    const getClientes = async () => {
      try {
        const res = await axios.get(clientesphp);
        const clientesArray = Object.entries(res.data).map(([id, nombre]) => ({
          id,
          nombre,
        }));
        setClientes(clientesArray);

        if (inputRef.current) {
          AutoComplete_Create(inputRef.current.id, clientesArray, 10);
        }
      } catch (error) {
        console.error("Error al obtener clientes:", error);
      }
    };

    getClientes();
    //Si se desmonta el componente, se destruye
    return () => {
      if (inputRef.current) {
        AutoComplete_Destroy(inputRef.current.id);
      }
    };
  }, []);

  // --------------------------------------------------------------------------------------------------------------

  //Creamos una función de validación para cuando se manden los datos
  /*
  const validateData = () => {
    if (selectedOption === "1") {
      // Persona física
      if (nombre.trim() === "") return "Campo Nombre vacío";
      if (ap_paterno.trim() === "") return "Campo de apellido paterno vacío";
      if (ap_materno.trim() === "") return "Campo de apellido materno vacío";
      if (tambien_conocido.trim() === "")
        return "Campo de también conocido como se encuentra vacío";
      if (id_nacionalidad === 0) return "Campo de nacionalidad no seleccionado";
      if (!fecha_nacimiento || String(fecha_nacimiento).trim() === "")
        return "Campo de fecha de nacimiento vacío";
      if (lugar_nacimiento.trim() === "")
        return "Campo de lugar de nacimiento vacío";
      if (ocupacion.trim() === "") return "Campo de ocupación vacío";
      if (curp.trim() === "") return "Campo de C.U.R.P. vacio";
      if (!curpRegex.test(curp.toUpperCase())) return "C.U.R.P. inválido";
      if (rfcphysics.trim() === "") return "Campo de R.F.C. vacío";
      if (!rfcRegexphysics.test(rfcphysics.toUpperCase()))
        return "RFC inválido";
      if (id_estado === 0) return "Campo de estado civil no seleccionado";
      if (id_estado === 1 && id_regimen === 0)
        return "Campo de régimen civil no seleccionado";

      // Domicilio
      if (calle.trim() === "") return "Campo de calle vacío";
      if (no_exterior.trim() === "") return "Campo de No. exterior vacío";
      if (colonia.trim() === "") return "Campo de colonia vacío";
      if (localidad.trim() === "") return "Campo de localidad vacío";
      if (ciudad.trim() === "") return "Campo de ciudad vacío";
      if (id_pais === 0) return "Campo de país no seleccionado";
      if (estado.trim() === "") return "Campo de estado vacío";
      if (cp.trim() === "") return "Campo de CP vacío";
      //Solo numeros en cp
      const cpRegex = /^\d+$/;
      if (!cpRegex.test(cp)) return "El campo de CP solo acepta números";

      // Contacto
      if (telefono_movil.trim() === "") return "Campo de teléfono móvil vacío";
      if (correo_electronico.trim() === "")
        return "Campo de correo electrónico está vacío";
      if (!emailRegex.test(correo_electronico.toUpperCase()))
        return "Correo electronico inválido";
    } else if (selectedOption === "2") {
      // Persona moral
      if (razon_social.trim() === "") return "Campo de razón social vacío";
      if (representante_legal.trim() === "")
        return "Campo de representante legal vacío";
      if (rfc_moral.trim() === "") return "Campo de RFC moral vacío";
      if (!rfcRegexlegalentity.test(rfc_moral.toUpperCase()))
        return "RFC moral inválido";

      // Domicilio
      if (calle.trim() === "") return "Campo de calle vacío";
      if (no_exterior.trim() === "") return "Campo de No. exterior vacío";
      if (colonia.trim() === "") return "Campo de colonia vacío";
      if (localidad.trim() === "") return "Campo de localidad vacío";
      if (ciudad.trim() === "") return "Campo de ciudad vacío";
      if (id_pais === 0) return "Campo de país no seleccionado";
      if (estado.trim() === "") return "Campo de estado vacío";
      if (cp.trim() === "") return "Campo de CP vacío";

      // Contacto
      if (telefono_movil.trim() === "") return "Campo de teléfono móvil vacío";
      if (correo_electronico.trim() === "")
        return "Campo de correo electrónico está vacío";
      if (!emailRegex.test(correo_electronico.toUpperCase()))
        return "Correo electronico inválido";
    }

    return "";
  };*/

  // Guardar cambios
  const handleSave = async () => {
    // Validamos que los datos que se subieron sean correctos
    const d = datosCliente;

    // Helper para texto vacío
    const isEmpty = (v) => !v || v.trim() === "";

    // =========================
    // PERSONA FÍSICA
    // =========================
    if (d.tipo_cliente === "1") {
      if (isEmpty(d.nombre)) {
        setMsgError("Campo Nombre vacío");
        return;
      }

      if (isEmpty(d.ap_paterno)) {
        setMsgError("Campo de apellido paterno vacío");
        return;
      }

      if (isEmpty(d.ap_materno)) {
        setMsgError("Campo de apellido materno vacío");
        return;
      }

      if (isEmpty(d.tambien_conocido)) {
        setMsgError("Campo de también conocido como se encuentra vacío");
        return;
      }

      if (!d.id_nacionalidad) {
        setMsgError("Campo de nacionalidad no seleccionado");
        return;
      }

      if (isEmpty(d.fecha_nacimiento)) {
        setMsgError("Campo de fecha de nacimiento vacío");
        return;
      }

      if (isEmpty(d.lugar_nacimiento)) {
        setMsgError("Campo de lugar de nacimiento vacío");
        return;
      }

      if (isEmpty(d.ocupacion)) {
        setMsgError("Campo de ocupación vacío");
        return;
      }

      if (isEmpty(d.curp)) {
        setMsgError("Campo de C.U.R.P. vacio");
        return;
      }

      if (!curpRegex.test(d.curp.toUpperCase())) {
        setMsgError("C.U.R.P. inválido");
        return;
      }

      if (isEmpty(d.rfc)) {
        setMsgError("Campo de R.F.C. vacío");
        return;
      }

      if (!rfcRegexphysics.test(d.rfc.toUpperCase())) {
        setMsgError("RFC inválido");
        return;
      }

      if (!d.id_estado) {
        setMsgError("Campo de estado civil no seleccionado");
        return;
      }

      if (Number(d.id_estado) === 1 && !d.id_regimen) {
        setMsgError("Campo de régimen civil no seleccionado");
        return;
      }
    }

    // =========================
    // PERSONA MORAL
    // =========================
    if (d.tipo_cliente === "2") {
      if (isEmpty(d.razon_social)) {
        setMsgError("Campo de razón social vacío");
        return;
      }

      if (isEmpty(d.representante)) {
        setMsgError("Campo de representante legal vacío");
        return;
      }

      if (isEmpty(d.rfc)) {
        setMsgError("Campo de RFC moral vacío");
        return;
      }

      if (!rfcRegexlegalentity.test(d.rfc.toUpperCase())) {
        setMsgError("RFC moral inválido");
        return;
      }
    }

    // =========================
    // DOMICILIO
    // =========================
    if (isEmpty(d.calle)) {
      setMsgError("Campo de calle vacío");
      return;
    }

    if (isEmpty(d.numero_exterior)) {
      setMsgError("Campo de No. exterior vacío");
      return;
    }

    if (isEmpty(d.colonia)) {
      setMsgError("Campo de colonia vacío");
      return;
    }

    if (isEmpty(d.localidad)) {
      setMsgError("Campo de localidad vacío");
      return;
    }

    if (isEmpty(d.ciudad)) {
      setMsgError("Campo de ciudad vacío");
      return;
    }

    if (isEmpty(d.estado)) {
      setMsgError("Campo de estado vacío");
      return;
    }

    if (!d.id_pais) {
      setMsgError("Campo de país no seleccionado");
      return;
    }

    if (isEmpty(d.cp)) {
      setMsgError("Campo de CP vacío");
      return;
    }

    // =========================
    // CONTACTO
    // =========================
    if (isEmpty(d.telefono_movil)) {
      setMsgError("Campo de teléfono móvil vacío");
      return;
    }

    if (isEmpty(d.mail)) {
      setMsgError("Campo de correo electrónico está vacío");
      return;
    }

    if (!emailRegex.test(d.mail.toUpperCase())) {
      setMsgError("Correo electronico inválido");
      return;
    }

    //Verificamos que no haya una vigencia vacia o en 0
    for (let archivo of archive) {
      //console.log("archivo vigencia", archivo.vigencia)
      if (!archivo.vigencia) {
        //console.log("Hay una vigencia vacía, no se envía al servidor");
        setMsgError("Algunos o todos los campos de vigencia están vacíos");
        setIsAlert(true);
        return; // detiene la función
      }
    }

    //Mapeamos en la variable archivosFormateados
    if (idcliente) {
      const archivosFormateados = archive.map((archivo) => ({
        nombre: archivo.nombre,
        fecha: archivo.vigencia || "",
      }));

      const datosClientechange = {
        id_user: id_user,
        ...datosCliente,
        id: idcliente,
        archivos: archivosFormateados,
      };
      //console.log("mis nuevos cambios", datosClientechange);
      //console.log("nuevos cambios", datosClientechange);

      //if (!validarCampos()) return console.log("los datos no son validos");
      setLoading(true); // Para que el boton no se ejecute el evento dos veces
      try {
        const res = await axios.post(clientesUpdatePhp, datosClientechange);
        if (res) {
          setIsAlert2(true);
          if (abrirBuscar === true) {
            if (boolAdquiriente) {
              setCerrarModal(false);

              agregarAdquiriente(datosClientechange);
            }
            if (boolOtorgante) {
              agregarOtorgante(datosClientechange);
              setCerrarModal(false);
            }
            //setAbrirBuscar(false);
          }
        }

        //alert("Cliente modificado correctamente");
        //window.location.reload();
        //console.log("Cliente actualizado:", res);
      } catch (error) {
        console.error("Error actualizando cliente:", error);
        alert("Error al guardar los datos");
      }
    } else {
      //alert("No ha seleccionado ningún cliente");
      setIsAlert3(true);
    }
  };
  // -------------------------------------------------------------------------------------------------------------------

  return (
    <>
      {isAlert2 ? (
        <>
          {abrirBuscar ? (
            <Alerts
              isShow={isAlert2}
              variant="success"
              head="Aviso"
              msg="Cliente editado correctamente"
              clicked={() => setAbrirBuscar(false)}
              textButton="OK"
            />
          ) : (
            <>
              <Alerts
                isShow={isAlert2}
                variant="success"
                head="Aviso"
                msg="Cliente editado correctamente"
                clicked={() => setIsCreated(true)}
                textButton="OK"
              />
            </>
          )}
        </>
      ) : (
        <div>
          <hr />
          <h5 className="mt-3">Editar la información de los clientes</h5>
          <p>
            Realize la busqueda de la información comenzando por el apellido
            paterno, luego el materno y al final el nombre.
          </p>
          <MDBRow>
            <MDBCol>
              <MDBInput
                id="clienteInput"
                ref={inputRef}
                type="text"
                value={busqueda}
                onChange={(e) => setBusqueda(e.target.value)}
                label="Ap. paterno, Ap. materno, Nombre"
                wrapperClass="w-100"
              />
              <MDBInput
                type="text"
                placeholder="ID Cliente"
                style={{
                  padding: "5px",
                  width: "100px",
                  marginLeft: "10px",
                  display: "none",
                }}
                value={idcliente}
                readOnly
              />
            </MDBCol>
          </MDBRow>

          {datosCliente.tipo_cliente === "1" && (
            <div className="mt-4">
              <MDBRow>
                <MDBCol>
                  <div style={{ position: "relative", width: "100%" }}>
                    <MDBInput
                      label="Nombre(s)"
                      type="text"
                      value={datosCliente.nombre || ""}
                      onChange={(e) => handleInputChange(e, "nombre")}
                      ref={nombreRef}
                    />
                    <span
                      style={{
                        position: "absolute",
                        bottom: "8px",
                        right: "12px",
                        color: "red",
                        fontWeight: "bold",
                        pointerEvents: "none",
                      }}
                    >
                      *
                    </span>
                  </div>
                </MDBCol>
              </MDBRow>

              <MDBRow className="mt-3">
                <MDBCol>
                  <div style={{ position: "relative", width: "100%" }}>
                    <MDBInput
                      label="Apellido paterno"
                      type="text"
                      value={datosCliente.ap_paterno || ""}
                      onChange={(e) => handleInputChange(e, "ap_paterno")}
                      ref={ap_paternoRef}
                    />
                    <span
                      style={{
                        position: "absolute",
                        bottom: "8px",
                        right: "12px",
                        color: "red",
                        fontWeight: "bold",
                        pointerEvents: "none",
                      }}
                    >
                      *
                    </span>
                  </div>
                </MDBCol>
                <MDBCol>
                  <div style={{ position: "relative", width: "100%" }}>
                    <MDBInput
                      label="Apellido materno"
                      type="text"
                      value={datosCliente.ap_materno || ""}
                      onChange={(e) => handleInputChange(e, "ap_materno")}
                      ref={ap_maternoRef}
                    />
                    <span
                      style={{
                        position: "absolute",
                        bottom: "8px",
                        right: "12px",
                        color: "red",
                        fontWeight: "bold",
                        pointerEvents: "none",
                      }}
                    >
                      *
                    </span>
                  </div>
                </MDBCol>
              </MDBRow>

              <MDBRow className="mt-3">
                <MDBCol>
                  <div style={{ position: "relative", width: "100%" }}>
                    <MDBInput
                      label="También conocido como"
                      type="text"
                      value={datosCliente.tambien_conocido || ""}
                      onChange={(e) => handleInputChange(e, "tambien_conocido")}
                      ref={tambien_conocidoRef}
                    />
                    <span
                      style={{
                        position: "absolute",
                        bottom: "8px",
                        right: "12px",
                        color: "red",
                        fontWeight: "bold",
                        pointerEvents: "none",
                      }}
                    >
                      *
                    </span>
                  </div>
                </MDBCol>
              </MDBRow>

              <MDBRow className="mt-3">
                <MDBCol>
                  <MDBCol>
                    <MDBCol>
                      <Form.Select
                        className="form-select"
                        value={
                          id_nacionalidad || datosCliente.id_nacionalidad || ""
                        }
                        onChange={handleChangeid_nacionalidad}
                        ref={id_nacionalidadRef}
                      >
                        <option value="">Selecciona tu nacionalidad</option>
                        {nacionalidades.map((n) => (
                          <option
                            key={n.id_nacionalidad}
                            value={n.id_nacionalidad}
                          >
                            {n.nacionalidad}
                          </option>
                        ))}
                      </Form.Select>
                    </MDBCol>
                  </MDBCol>
                </MDBCol>

                <MDBCol>
                  <DatePicker
                    selected={
                      datosCliente.fecha_nacimiento
                        ? (() => {
                            const parts =
                              datosCliente.fecha_nacimiento.split("-");
                            return new Date(parts[0], parts[1] - 1, parts[2]);
                          })()
                        : null
                    }
                    onChange={(date) => {
                      if (!date) {
                        setDatosCliente((prev) => ({
                          ...prev,
                          fecha_nacimiento: "",
                        }));
                        return;
                      }

                      const yyyy = date.getFullYear();
                      const mm = String(date.getMonth() + 1).padStart(2, "0");
                      const dd = String(date.getDate()).padStart(2, "0");

                      const fechaLocal = `${yyyy}-${mm}-${dd}`;

                      //console.log("Fecha correcta guardada:", fechaLocal);

                      setDatosCliente((prev) => ({
                        ...prev,
                        fecha_nacimiento: fechaLocal,
                      }));
                    }}
                    dateFormat="yyyy-MM-dd"
                    className="form-control"
                    placeholderText="Selecciona tu fecha de nacimiento"
                    wrapperClassName="w-100"
                    showYearDropdown
                    scrollableYearDropdown
                    yearDropdownItemNumber={100}
                    ref={fecha_nacimientoRef}
                    customInput={<CustomDateInput />}
                  />
                </MDBCol>
              </MDBRow>

              <MDBRow className="mt-3">
                <MDBCol>
                  <div style={{ position: "relative", width: "100%" }}>
                    <MDBInput
                      label="Lugar de nacimiento"
                      type="text"
                      value={datosCliente.lugar_nacimiento || ""}
                      onChange={(e) => handleInputChange(e, "lugar_nacimiento")}
                      ref={lugar_nacimientoRef}
                    />
                    <span
                      style={{
                        position: "absolute",
                        bottom: "8px",
                        right: "12px",
                        color: "red",
                        fontWeight: "bold",
                        pointerEvents: "none",
                      }}
                    >
                      *
                    </span>
                  </div>
                </MDBCol>
              </MDBRow>

              <MDBRow className="mt-3">
                <MDBCol>
                  <div style={{ position: "relative", width: "100%" }}>
                    <MDBInput
                      label="Ocupación"
                      type="text"
                      value={datosCliente.ocupacion || ""}
                      onChange={(e) => handleInputChange(e, "ocupacion")}
                      ref={ocupacionRef}
                    />
                    <span
                      style={{
                        position: "absolute",
                        bottom: "8px",
                        right: "12px",
                        color: "red",
                        fontWeight: "bold",
                        pointerEvents: "none",
                      }}
                    >
                      *
                    </span>
                  </div>
                </MDBCol>
              </MDBRow>

              <MDBRow className="mt-3">
                <MDBCol>
                  <div style={{ position: "relative", width: "100%" }}>
                    <MDBInput
                      label="C.U.R.P."
                      type="text"
                      value={datosCliente.curp || ""}
                      onChange={(e) => handleInputChange(e, "curp")}
                      ref={curpRef}
                    />
                    <span
                      style={{
                        position: "absolute",
                        bottom: "8px",
                        right: "12px",
                        color: "red",
                        fontWeight: "bold",
                        pointerEvents: "none",
                      }}
                    >
                      *
                    </span>
                  </div>
                </MDBCol>

                <MDBCol>
                  <div style={{ position: "relative", width: "100%" }}>
                    <MDBInput
                      label="R.F.C."
                      type="text"
                      value={datosCliente.rfc || ""}
                      onChange={(e) => handleInputChange(e, "rfc")}
                      ref={rfcRef}
                    />
                    <span
                      style={{
                        position: "absolute",
                        bottom: "8px",
                        right: "12px",
                        color: "red",
                        fontWeight: "bold",
                        pointerEvents: "none",
                      }}
                    >
                      *
                    </span>
                  </div>
                </MDBCol>
              </MDBRow>

              <MDBRow className="mt-3">
                <MDBCol>
                  <Form.Select
                    className="form-select"
                    value={id_estado || datosCliente.id_estado || ""}
                    onChange={handleChangeid_estado}
                    ref={id_estadoRef}
                  >
                    <option value="" key={0}>
                      Selecciona el estado civil
                    </option>
                    {estados.map((e) => (
                      <option key={e.id_estado} value={e.id_estado}>
                        {e.estado}
                      </option>
                    ))}
                  </Form.Select>
                </MDBCol>

                <MDBCol>
                  <Form.Select
                    className="form-select"
                    value={id_regimen || datosCliente.id_regimen || ""}
                    onChange={handleChangeid_regimen}
                    ref={id_regimenRef}
                    disabled={Number(id_estado || datosCliente.id_estado) !== 1}
                  >
                    <option value="" key={0}>
                      Selecciona el régimen matrimonial
                    </option>
                    {regimenes.map((r) => (
                      <option key={r.id_regimen} value={r.id_regimen}>
                        {r.regimen}
                      </option>
                    ))}
                  </Form.Select>
                </MDBCol>
              </MDBRow>

              <MDBRow className="mt-3">
                <MDBCol>
                  <Form.Select
                    className="form-select"
                    value={
                      id_regimen_fiscal || datosCliente.id_regimen_fiscal || ""
                    }
                    onChange={handleChangeid_regimen_fiscal}
                  >
                    <option value="">Selecciona tu régimen fiscal</option>
                    {regimenesFiscales.map((rf) => (
                      <option
                        key={rf.id_regimen_fiscal}
                        value={rf.id_regimen_fiscal}
                      >
                        {rf.regimen_fiscal}
                      </option>
                    ))}
                  </Form.Select>
                </MDBCol>
              </MDBRow>
            </div>
          )}

          {datosCliente.tipo_cliente === "2" && (
            <div className="mt-4">
              <MDBRow>
                <MDBCol>
                  <div style={{ position: "relative", width: "100%" }}>
                    <MDBInput
                      label="Razón social"
                      type="text"
                      value={datosCliente.razon_social || ""}
                      onChange={(e) => handleInputChange(e, "razon_social")}
                      ref={razon_socialRef}
                    />
                    <span
                      style={{
                        position: "absolute",
                        bottom: "8px",
                        right: "12px",
                        color: "red",
                        fontWeight: "bold",
                        pointerEvents: "none",
                      }}
                    >
                      *
                    </span>
                  </div>
                </MDBCol>
              </MDBRow>
              <MDBRow className="mt-3">
                <MDBCol>
                  <div style={{ position: "relative", width: "100%" }}>
                    <MDBInput
                      label="Representante legal"
                      type="text"
                      value={datosCliente.representante || ""}
                      onChange={(e) => handleInputChange(e, "representante")}
                      ref={representante_legalRef}
                    />
                    <span
                      style={{
                        position: "absolute",
                        bottom: "8px",
                        right: "12px",
                        color: "red",
                        fontWeight: "bold",
                        pointerEvents: "none",
                      }}
                    >
                      *
                    </span>
                  </div>
                </MDBCol>
                <MDBCol>
                  <div style={{ position: "relative", width: "100%" }}>
                    <MDBInput
                      label="RFC"
                      type="text"
                      value={datosCliente.rfc || ""}
                      ref={rfc_moralRef}
                      onChange={(e) => handleInputChange(e, "rfc")}
                    />
                    <span
                      style={{
                        position: "absolute",
                        bottom: "8px",
                        right: "12px",
                        color: "red",
                        fontWeight: "bold",
                        pointerEvents: "none",
                      }}
                    >
                      *
                    </span>
                  </div>
                </MDBCol>
              </MDBRow>
            </div>
          )}

          {/* Domicilio */}
          {datosCliente.tipo_cliente && (
            <div className="fieldset-container mt-4">
              <span className="fieldset-title">Domicilio</span>
              <MDBRow className="mt-3">
                <MDBCol>
                  <div style={{ position: "relative", width: "100%" }}>
                    <MDBInput
                      label="Calle"
                      type="text"
                      value={datosCliente.calle || ""}
                      ref={calleRef}
                      onChange={(e) => handleInputChange(e, "calle")}
                    />
                    <span
                      style={{
                        position: "absolute",
                        bottom: "8px",
                        right: "12px",
                        color: "red",
                        fontWeight: "bold",
                        pointerEvents: "none",
                      }}
                    >
                      *
                    </span>
                  </div>
                </MDBCol>
              </MDBRow>
              <MDBRow className="mt-3">
                <MDBCol>
                  <div style={{ position: "relative", width: "100%" }}>
                    <MDBInput
                      label="No. Exterior"
                      type="text"
                      ref={no_exteriorRef}
                      value={datosCliente.numero_exterior || ""}
                      onChange={(e) => {
                        handleInputChange(
                          { target: { value: e.target.value } },
                          "numero_exterior",
                        );
                      }}
                    />
                    <span
                      style={{
                        position: "absolute",
                        bottom: "8px",
                        right: "12px",
                        color: "red",
                        fontWeight: "bold",
                        pointerEvents: "none",
                      }}
                    >
                      *
                    </span>
                  </div>
                </MDBCol>
                <MDBCol>
                  <div style={{ position: "relative", width: "100%" }}>
                    <MDBInput
                      label="No. Interior"
                      type="text"
                      value={datosCliente.numero_interior || ""}
                      onChange={(e) => {
                        handleInputChange(
                          { target: { value: e.target.value } },
                          "numero_interior",
                        );
                      }}
                    />
                  </div>
                </MDBCol>
              </MDBRow>
              <MDBRow className="mt-3">
                <MDBCol>
                  <div style={{ position: "relative", width: "100%" }}>
                    <MDBInput
                      label="Colonia"
                      type="text"
                      value={datosCliente.colonia || ""}
                      onChange={(e) => handleInputChange(e, "colonia")}
                      ref={coloniaRef}
                    />
                    <span
                      style={{
                        position: "absolute",
                        bottom: "8px",
                        right: "12px",
                        color: "red",
                        fontWeight: "bold",
                        pointerEvents: "none",
                      }}
                    >
                      *
                    </span>
                  </div>
                </MDBCol>
              </MDBRow>

              <MDBRow className="mt-3">
                <MDBCol>
                  <div style={{ position: "relative", width: "100%" }}>
                    <MDBInput
                      label="Localidad"
                      type="text"
                      value={datosCliente.localidad || ""}
                      onChange={(e) => handleInputChange(e, "localidad")}
                      ref={localidadRef}
                    />
                    <span
                      style={{
                        position: "absolute",
                        bottom: "8px",
                        right: "12px",
                        color: "red",
                        fontWeight: "bold",
                        pointerEvents: "none",
                      }}
                    >
                      *
                    </span>
                  </div>
                </MDBCol>
                <MDBCol>
                  <div style={{ position: "relative", width: "100%" }}>
                    <MDBInput
                      label="Ciudad"
                      type="text"
                      value={datosCliente.ciudad || ""}
                      onChange={(e) => handleInputChange(e, "ciudad")}
                      ref={ciudadRef}
                    />
                    <span
                      style={{
                        position: "absolute",
                        bottom: "8px",
                        right: "12px",
                        color: "red",
                        fontWeight: "bold",
                        pointerEvents: "none",
                      }}
                    >
                      *
                    </span>
                  </div>
                </MDBCol>
              </MDBRow>

              <MDBRow className="mt-3">
                <MDBCol>
                  <div style={{ position: "relative", width: "100%" }}>
                    <MDBInput
                      label="Estado"
                      type="text"
                      value={datosCliente.estado || ""}
                      onChange={(e) => handleInputChange(e, "estado")}
                      ref={estadoRef}
                    />
                    <span
                      style={{
                        position: "absolute",
                        bottom: "8px",
                        right: "12px",
                        color: "red",
                        fontWeight: "bold",
                        pointerEvents: "none",
                      }}
                    >
                      *
                    </span>
                  </div>
                </MDBCol>
                <MDBCol>
                  <Form.Select
                    className="form-select"
                    value={id_pais || datosCliente.id_pais || ""}
                    onChange={handleChangePais}
                    ref={id_paisRef}
                  >
                    <option value="">Selecciona tu país</option>
                    {paises.map((p) => (
                      <option key={p.id_pais} value={p.id_pais}>
                        {p.pais}
                      </option>
                    ))}
                  </Form.Select>
                </MDBCol>
              </MDBRow>

              <MDBRow className="mt-3">
                <MDBCol>
                  <div style={{ position: "relative", width: "100%" }}>
                    <MDBInput
                      label="CP"
                      type="text"
                      ref={cpRef}
                      value={datosCliente.cp || ""}
                      onChange={(e) => {
                        // Evitar que se ingresen caracteres no numéricos
                        handleInputChange(e, "cp");
                      }}
                    />
                    <span
                      style={{
                        position: "absolute",
                        bottom: "8px",
                        right: "12px",
                        color: "red",
                        fontWeight: "bold",
                        pointerEvents: "none",
                      }}
                    >
                      *
                    </span>
                  </div>
                </MDBCol>
              </MDBRow>
            </div>
          )}

          {/* Contacto editable */}
          {datosCliente.tipo_cliente && (
            <div className="fieldset-container mt-4">
              <span className="fieldset-title">Contacto</span>
              <MDBRow className="mt-3">
                <MDBCol>
                  <div style={{ position: "relative", width: "100%" }}>
                    <MDBInput
                      label="Teléfono particular"
                      type="text"
                      value={datosCliente.telefono_particular || ""}
                      onChange={(e) =>
                        handleInputChange(e, "telefono_particular")
                      }
                    />
                  </div>
                </MDBCol>
                <MDBCol>
                  <div style={{ position: "relative", width: "100%" }}>
                    <MDBInput
                      label="Teléfono oficina"
                      type="text"
                      value={datosCliente.telefono_oficina || ""}
                      onChange={(e) => handleInputChange(e, "telefono_oficina")}
                    />
                  </div>
                </MDBCol>
              </MDBRow>
              <MDBRow className="mt-3">
                <MDBCol>
                  <div style={{ position: "relative", width: "100%" }}>
                    <MDBInput
                      label="Teléfono móvil"
                      type="text"
                      value={datosCliente.telefono_movil || ""}
                      ref={telefono_movilRef}
                      onChange={(e) => handleInputChange(e, "telefono_movil")}
                    />
                    <span
                      style={{
                        position: "absolute",
                        bottom: "8px",
                        right: "12px",
                        color: "red",
                        fontWeight: "bold",
                        pointerEvents: "none",
                      }}
                    >
                      *
                    </span>
                  </div>
                </MDBCol>
                <MDBCol>
                  <div style={{ position: "relative", width: "100%" }}>
                    <MDBInput
                      label="Correo electrónico"
                      type="text"
                      ref={correo_electronicoRef}
                      value={datosCliente.mail || ""}
                      onChange={(e) => handleInputChange(e, "mail")}
                    />
                    <span
                      style={{
                        position: "absolute",
                        bottom: "8px",
                        right: "12px",
                        color: "red",
                        fontWeight: "bold",
                        pointerEvents: "none",
                      }}
                    >
                      *
                    </span>
                  </div>
                </MDBCol>
              </MDBRow>
              <MDBRow className="mt-3">
                <MDBCol>
                  <MDBTextArea
                    label="Observaciones generales"
                    value={datosCliente.observaciones || ""}
                    onChange={(e) => handleInputChange(e, "observaciones")}
                  />
                </MDBCol>
              </MDBRow>
            </div>
          )}

          {datosCliente.tipo_cliente && (
            <div className="fieldset-container">
              <span className="fieldset-title">Archivos</span>
              <div>
                {/* Renderizar archive */}
                <div>
                  {archive.map((archivoItem, index) => {
                    //console.log("archivoItem", archivoItem.nombre);
                    const expirar = file_date(
                      archivoItem.vigencia,
                      archivoItem.fecha_carga,
                    );
                    //console.log("archivoItem", archivoItem.nombre);
                    // console.log("fecha carga archivo",  archivoItem.vigencia)
                    // console.log("fecha carga archivo",  archivoItem.fecha_carga)

                    //console.log("El archivo expira:", expirar);

                    return (
                      <div
                        key={`${archivoItem.id}-${index}`}
                        style={{
                          backgroundColor: expirar ? "#fe8484ff" : "#ffffff",
                        }}
                        className={`border p-2 m-2 flex items-center gap-2`}
                      >
                        <MDBRow>
                          <MDBCol size="auto">
                            <button
                              type="button"
                              className="p-0 border-0 bg-transparent"
                              onClick={() =>
                                delete_files(
                                  archivoItem.nombre,
                                  archivoItem.id_documento,
                                )
                              }
                            >
                              <img
                                src={tache}
                                width="40"
                                height="25"
                                alt="icono"
                              />
                            </button>
                          </MDBCol>

                          <MDBCol>
                            <a
                              className="m-0"
                              style={{
                                color: "#000000ff",
                                textDecoration: "underline",
                                cursor: "pointer",
                                display: "inline-block",
                                padding: "4px",
                                textDecoration: "none",
                              }}
                              href={`https://n4col.com/docs/${archivoItem.nombre}`}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {archivoItem.nombre}
                            </a>
                          </MDBCol>

                          <MDBCol>
                            <MDBInput
                              label="Vigencia en meses"
                              type="number"
                              value={archivoItem.vigencia ?? ""}
                              onChange={(e) => {
                                const newArchive = [...archive]; // copiar el estado original
                                newArchive[index].vigencia = e.target.value; // actualizar solo la vigencia
                                setArchive(newArchive); // actualizar estado
                              }}
                              onWheel={(e) => e.target.blur()}
                            />
                          </MDBCol>
                        </MDBRow>
                      </div>
                    );
                  })}
                </div>

                {showModal &&
                  ReactDOM.createPortal(
                    <div className="modal show d-block">
                      {/* ocupa el 80% del alto */}
                      <div
                        className="modal-body"
                        style={{ fontSize: "30px" }}
                        dangerouslySetInnerHTML={{ __html: modalHTML }}
                      />
                      <div className="modal-footer">
                        <button
                          type="button"
                          className="btn btn-secondary"
                          onClick={handleCloseModal}
                        >
                          Cerrar
                        </button>
                      </div>
                    </div>,
                    document.body,
                  )}

                <div className="d-flex justify-content-end">
                  <button
                    type="button"
                    className="btn btn-primary mb-2"
                    onClick={handleOpenModal}
                  >
                    Subir Archivos
                  </button>
                </div>
              </div>
            </div>
          )}

          <MDBRow className="mt-4">
            {(isAlert || msgError !== "") && (
              <Alerts
                isShow={isAlert || msgError !== ""}
                variant="danger"
                head="Error de Registro"
                msg={
                  msgError !== ""
                    ? msgError
                    : "Se requieren todos los campos para el registro"
                }
                clicked={() => {
                  setIsAlert(false);
                  const ref = getRefFromError();
                  //console.log("retorna", ref)
                  focusAndHighlight(ref);
                  setMsgError("");
                }}
                textButton="OK"
                variantButton={"outline-danger"}
              />
            )}
          </MDBRow>

          <MDBRow className="mt-4">
            {isAlert3 && (
              <Alerts
                isShow={isAlert3}
                variant="danger"
                head="Error"
                msg="No se ha seleccionado un cliente"
                clicked={() => setIsAlert3(false)}
                textButton="OK"
                variantButton={"outline-danger"}
              />
            )}
          </MDBRow>
          <MDBRow className="d-flex justify-content-between align-items-center">
            {abrirBuscar ? (
              <>
                <MDBCol className="col-auto">
                  <button
                    className="btn btn-warning"
                    onClick={() => cerrar_Modal()}
                    style={{
                      borderRadius: "8px",
                      fontWeight: "bold",
                    }}
                  >
                    ⟵
                  </button>
                </MDBCol>
              </>
            ) : (
              <>
                {" "}
                <MDBCol className="col-auto">
                  <button
                    className="btn btn-warning"
                    onClick={() => window.location.reload()}
                    style={{
                      borderRadius: "8px",
                      fontWeight: "bold",
                    }}
                  >
                    ⟵
                  </button>
                </MDBCol>
              </>
            )}
            <MDBCol className="col-auto">
              <button
                className="btn btn-primary"
                disabled={loading}
                onClick={handleSave}
              >
                Guardar cambios
              </button>
            </MDBCol>
          </MDBRow>
        </div>
      )}
    </>
  );
};

export default EditC;
